angular.module('app').directive('trsResOperCtrl', function(){
    return {
        scope: true,
        restrict: 'AE',
        templateUrl: './resourceCenter/directive/operationBtns/operationBtns.html',
        replace: true,
        transclude:{
            'rightMore': '?rightMore'
        },
        link: function($scope, iElm, iAttrs, controller) {

            $scope.isShowBtn = function(type){
                return $scope.status.btns.indexOf(type) !== -1;
            };
        }
    };
});
